/**
 * @fileoverview Agent definition for world-element-core-detector-v3.
 *
 * Surface-level detection of world elements using proper nouns, explicit
 * mentions, and named entities.
 *
 * @category world-building.extraction.detection
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-element-core-detector-v3',
  kind: 'primitive',
  name: 'World Element Core Detector',
  description: 'Surface-level detection of world elements. Primary: Place, Organization, Object, Event. Also catches prominent Set, Species, System.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.extraction.detection',
    usedBy: [],
    usedInComposites: ['extract-world-elements-v3'],
    relatedAgents: [
      'world-element-rare-detector-v3',
      'world-element-detailer-v3',
    ],
  },
};
